import { AfterContentChecked, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

import { Atto } from 'src/app/common/models/atto';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import { TipoAtto } from 'src/app/common/models/tipologiche/tipo-atto';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';

@Component({
  selector: 'app-step-atti',
  templateUrl: './step-atti.component.html'
})
export class StepAttiComponent implements OnInit, AfterContentChecked {
  @ViewChild('bottom', { read: ElementRef }) bottom: ElementRef<HTMLElement>;

  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>()
  isShowForm: boolean = false;
  atti: Atto[] = [];
  tipiAttiStore: ElaborationDocumentFilterEntity[];
  datePubblicazioniSuggerite: ElaborationDocumentFilterEntity[];
  dateDepositoSuggerite: ElaborationDocumentFilterEntity[];
  tipiAttiSuggeriti: TipoAtto[];
  attoToEdit: Atto;
  indexAttoToEdit: number;
  tipiAttoList: String[] = [];
  attiSuggeriti: Atto[] = [];
  attoAssociato: Atto;
  isScroll: boolean = false;
  isEdit = false;


  constructor(private creazionePraticaStoreService: CreazionePraticaStoreService,
              private tipologicheService: CreazionePraticaTipologicheService) {}

  ngOnInit() {

    this.getAttiFromStore();

    this.tipologicheService.getTipiAtto().subscribe(tipiAtto => {
      this.tipiAttoList = tipiAtto.map(el => el.label);

      this.creazionePraticaStoreService.entities$.subscribe(entities => {

        // let fakeTipoAtto: ElaborationDocumentFilterEntity;
        // fakeTipoAtto = {
        //   tipoEntita: {
        //     id: '1',
        //     rimosso: false,
        //     label: 'GIURISPRUDENZA',
        //     descrizione: 'GIURISPRUDENZA'
        //   },
        //   elaborazioneDocumento: {
        //     id: 'a',
        //     refDocumentale: 'a',
        //     testoEstratto: 'a'
        //   },
        //   valore: 'CITAZIONE - VARIE',
        //   occorrenze: [{
        //     id: 'a',
        //     inizio: 1,
        //     fine: 10,
        //     link: [{
        //       id: 'a',
        //       idEntita: 'a'
        //     }]
        //   }]
        // }
        // let fakeDataPubblicazione: ElaborationDocumentFilterEntity;
        // fakeDataPubblicazione = {
        //   tipoEntita: {
        //     id: '1',
        //     rimosso: false,
        //     label: 'publish_date',
        //     descrizione: 'publish_date'
        //   },
        //   elaborazioneDocumento: {
        //     id: 'a',
        //     refDocumentale: 'a',
        //     testoEstratto: 'a'
        //   },
        //   valore: '12/03/2018',
        //   occorrenze: [{
        //     id: 'a',
        //     inizio: 15,
        //     fine: 25,
        //     link: [{
        //       id: 'a',
        //       idEntita: 'a'
        //     }]
        //   }]
        // }
        // let fakeDataDecisione: ElaborationDocumentFilterEntity;
        // fakeDataDecisione = {
        //   tipoEntita: {
        //     id: '1',
        //     rimosso: false,
        //     label: 'decision_date',
        //     descrizione: 'decision_date'
        //   },
        //   elaborazioneDocumento: {
        //     id: 'a',
        //     refDocumentale: 'a',
        //     testoEstratto: 'a'
        //   },
        //   valore: '14/01/2019',
        //   occorrenze: [{
        //     id: 'a',
        //     inizio: 28,
        //     fine: 38,
        //     link: [{
        //       id: 'a',
        //       idEntita: 'a'
        //     }]
        //   }]
        // }

        // let ar = entities;
        // ar.push(fakeTipoAtto);
        // ar.push(fakeDataDecisione);
        // ar.push(fakeDataPubblicazione);
        // this.creazionePraticaStoreService.setEntities(ar)

        //recupero entities etichettate com 'GIURISPRUDENZA', 'PUBLISH_DATA', 'DECISION_DATE'
        this.filterEntities(entities);

        //tra i tipi atto suggeriti, prendo solo quelli con valore valido (presenti in TPL_TIPI_ATTO)
        this.tipiAttiStore = this.tipiAttiStore.filter(el =>
          this.tipiAttoList.includes(el.valore)
        );

        //dal tipo atto suggerito (ElaborationDocumentFilterEntity[]) passo a tipoAtto (TipoAtto[])
        this.tipiAttiSuggeriti = tipiAtto.filter(el =>
          this.tipiAttiStore.map(attoStore => attoStore.valore).includes(el.label)
        );

        //costruisco gli atti suggeriti (tutte combinazioni di tipi atto, data pubblicazione e data deposito, ma deve esistere almeno un tipo atto)
        this.createAttiByEntities(this.tipiAttiSuggeriti, this.datePubblicazioniSuggerite,
          this.dateDepositoSuggerite);
      });
    });


    /*if(this.atti.length > 0) {
      this.isShowList = true;
    } else {
      this.isShowForm = true;
    }*/
    //TSR-652: Mostrare sempre la lista di default
    this.isShowForm = false;
  }

  ngAfterContentChecked(): void {
    if (this.isScroll) {
      this.scroll(this.bottom.nativeElement);
    }
  }

  ngAfterViewChecked(): void {
    if(this.isScroll){
      this.scroll(this.bottom.nativeElement);
      this.isScroll = false;
    }
  }

  getAttiFromStore() {
    this.creazionePraticaStoreService.atti$.subscribe((atti => {
      if(!atti){
        this.creazionePraticaStoreService.setAtti([]);
      }
      else {
        this.atti = atti ? atti : [];
      }
    }));
  }

  onFormAtto() {
    this.isShowForm = true;
  }

  onShowList() {
    this.getAttiFromStore();
    this.isShowForm = false;
  }

  onSave(atto: Atto) {
    //se aggiungo atto
    if(this.attoToEdit === undefined) {
      this.creazionePraticaStoreService.addAtto(atto);
      this.attoToEdit = undefined;
      this.attoAssociato = undefined;
    }
    else {
      //se modifico un atto esistente
      this.atti[this.indexAttoToEdit] = atto;
      this.creazionePraticaStoreService.setAtti(this.atti);
      this.attoToEdit = undefined;
      this.indexAttoToEdit = undefined;
    }
    this.isEdit = false;
    this.onShowList();
    this.creazionePraticaStoreService.save();
  }

  associa(atto: Atto) {
    //passa atto prevalorizzato al form e mostra il form
    this.onFormAtto();
    this.attoAssociato = atto;
    this.isScroll = true;
  }

  deleteAtto(index: number) {
    this.atti.splice(index, 1);
    this.creazionePraticaStoreService.setAtti(this.atti);
    this.creazionePraticaStoreService.save();
  }

  editAtto(index: number) {
    this.onFormAtto();
    this.attoToEdit = this.atti[index];
    this.indexAttoToEdit = index;
    this.isScroll = true;
    this.isEdit = true;
  }

  reset() {
    this.creazionePraticaStoreService.setAtti([]);
    this.creazionePraticaStoreService.save();
  }

  prosegui() {
    this.changeStep.emit();
  }

  pulisciCampi() {
    this.attoAssociato = undefined;
    this.attoToEdit = undefined;
  }


  annullaModifica() {
    this.attoToEdit = undefined;
    this.attoAssociato = undefined;
    this.isEdit = false;
    this.onShowList();
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }


  private filterEntities(entities: ElaborationDocumentFilterEntity[]) {
    this.tipiAttiStore = entities.filter(el =>
      el.tipoEntita.label_key.toUpperCase() === 'GIURISPRUDENZA'
    );
    this.datePubblicazioniSuggerite = entities.filter(el =>
      el.tipoEntita.label_key.toUpperCase() === 'PUBLISH_DATE'
    );
    this.dateDepositoSuggerite = entities.filter(el =>
      el.tipoEntita.label_key.toUpperCase() === 'DECISION_DATE'
    );
  }

  private createAttiByEntities(tipiAtto: TipoAtto[],
    datePubblicazione: ElaborationDocumentFilterEntity[],
    dateDeposito: ElaborationDocumentFilterEntity[]) {
      for(var tipoAtto of tipiAtto) {
        let atto: Atto = new Atto();
        atto.tipoAtto = new TipoAtto();
        atto.tipoAtto = JSON.parse(JSON.stringify(tipoAtto));
        for(var dataPubblicazione of datePubblicazione) {
          atto.dataPubblicazione = this.dateStringToDate(dataPubblicazione.valore);
          for(var dataDeposito of dateDeposito) {
            atto.dataDeposito = this.dateStringToDate(dataDeposito.valore);
            let attoTmp: Atto = new Atto();
            attoTmp = JSON.parse(JSON.stringify(atto));
            this.attiSuggeriti.push(attoTmp);
          }
          if(atto.dataDeposito  === undefined) {
            let attoTmp: Atto = new Atto();
            attoTmp = JSON.parse(JSON.stringify(atto));
            this.attiSuggeriti.push(attoTmp);
          }
        }
        if(atto.dataPubblicazione === undefined) {
          for (var dataDeposito of dateDeposito) {
            atto.dataDeposito = this.dateStringToDate(dataDeposito.valore);
            let attoTmp: Atto = new Atto();
            attoTmp = JSON.parse(JSON.stringify(atto));
            this.attiSuggeriti.push(attoTmp);
          }
          if(atto.dataDeposito === undefined) {
            let attoTmp: Atto = new Atto();
            attoTmp = JSON.parse(JSON.stringify(atto));
            this.attiSuggeriti.push(attoTmp);
          }
        }
        if(atto.dataPubblicazione === undefined && atto.dataDeposito === null) {
          let attoTmp: Atto = new Atto();
          attoTmp = JSON.parse(JSON.stringify(atto));
          this.attiSuggeriti.push(attoTmp);
        }
      }
  }


  private dateStringToDate(dateString: String) {
    let parts: any = dateString.split('/'); //  formato dd/mm/yyyy
    return new Date(parts[2], parts[1] - 1, parts[0]).valueOf();
  }

}
